$(document).ready(function () {
  //$("html, body").animate({ scrollTop: 0 }, "fast");
  $("#quizForm").find("input[type='checkbox']").prop("checked", false);
  $("#quizBranding").hide();
  $(".progress-container").hide();
  $("body").addClass("withBackgroundImage");
  //$("#slide3Checkbox").click();

  function adjustSlideHeight() {
    var windowWidth = $(window).width();
    if (windowWidth > 1024) {
      var aspectRatioHeight = (1684 / 2880) * windowWidth;
      $(".slide0").css("height", aspectRatioHeight + "px");
      //$("#questionnaire").css("height", aspectRatioHeight + "px");
      var slide0H1paddingTop = aspectRatioHeight * 0.14;
      $(".slide0 h1").css("padding-top", slide0H1paddingTop + "px");
    } else {
      $(".slide0").css("height", "100vh");
      //$("#questionnaire").css("height", "100vh");
      $(".slide1").css("height", "100vh");
      $(".slide0 h1").css("padding-top", "20%");
    }
    if (windowWidth > 1024 && windowWidth < 1440) {
      $(".slide0 h1").css("padding-top", "2%");
    }
  }

  function adjustSlideHeight2() {
    var windowWidth = $(window).width();
    if (windowWidth > 1024) {
      var aspectRatioHeight = (1684 / 2880) * windowWidth;
      //$(".slide0").css("height", aspectRatioHeight + "px");
      //$("#questionnaire").css("height", aspectRatioHeight + "px");
      var slide0H1paddingTop = aspectRatioHeight * 0.14;
      $(".slide0 h1").css("padding-top", slide0H1paddingTop + "px");
    } else {
      $(".slide0").css("height", "100vh");
      //$("#questionnaire").css("height", "100vh");
      $(".slide1").css("height", "100vh");
      $(".slide0 h1").css("padding-top", "20%");
    }
    if (windowWidth > 1024 && windowWidth < 1440) {
      $(".slide0 h1").css("padding-top", "2%");
    }
  }

  // Initial call to set the height on page load
  //adjustSlideHeight();

  // Adjust the height on window resize
  $(window).resize(function () {
    let activeSlide = $(".slide.active");
    if (activeSlide.hasClass("slide0")) {
      //adjustSlideHeight();
    } else {
      //adjustSlideHeight2();
    }
  });

  function validateSlide() {
    return $(".slide.active input[type='checkbox']:checked").length > 0;
  }

  function validateSlideSingle() {
    const checkedCheckboxes = $(".slide.active input[type='checkbox']:checked");
    return checkedCheckboxes.length === 1;
  }

  function adjustContainerHeight() {
    var activeSlideHeight = $(".slide.active").outerHeight();
    //$("#questionnaire").height(activeSlideHeight);
  }

  /*function changeSlide($current, $next, direction) {
    $current
      .removeClass("active")
      .css("left", direction === "next" ? "-100%" : "100%");
    $next.addClass("active").css("left", "0");
    adjustContainerHeight();
    updateProgressBar($next.index());
  }*/

  function changeSlide($current, $next, direction) {
    $current
      .removeClass("active")
      .css("left", direction === "next" ? "-100%" : "100%");
    $next.addClass("active").css("left", "0");
    $(".slide.active .col-md-12").addClass("animated-div");
    adjustContainerHeight();
    updateProgressBar($next.index());
    //updateBodyBackgroundColor($next);
  }

  function updateBodyBackgroundColor($nextSlide) {
    if ($nextSlide.is(":last-child")) {
      $("body").css("background-color", "white");
    } else {
      $("body").css("background-color", "white");
    }
  }

  function updateProgressBar(index) {
    //$("body").removeClass("withBackgroundImage");
    //$("body").removeClass("whiteBG");
    $(".progress-bar").removeClass("active");

    if (index != 1) {
      $(".prev").show();
    }

    if (index === 3) {
      //$("#compatibleResultsWrapper, #landingPageItems, #coverageCheckerA").hide();
      //$("body").css("background-color", "#000000");
      $("html, body").animate({ scrollTop: 0 }, "fast");
    }

    if (index < 6) {
      // Update for the progress bar
      $("#progress" + index).addClass("active");
    }

    if (index === 2) {
      $(".progress-container").hide();
      $("body").addClass("whiteBG");
      $("#quizBranding").hide();
      $(
        "#coverageCheckerA, #deviceComparo, #resultsDetails, #threeMatchesForYourCar, .custom-scrollbar, .aseInfoRow.blackVersion.v2"
      ).show();
      //$("#questionnaire").css("min-height", "980px");

      var windowWidth = $(window).width();
      if (windowWidth < 960) {
        $("#questionnaire").css("min-height", "100vh");
        $("#questionnaire").attr("style", "min-height: 100vh !important;");
      } else if (windowWidth <= 1800) {
        $("#questionnaire").css("min-height", "900px");
      } else {
        $("#questionnaire").css("min-height", "960px");
      }

      $(".aseInfoRow.whiteVersion, .aseInfoRow.blackVersion.v1").hide();
      $(".nav-link-3.w-nav-link").show();
      setTimeout(function () {
        $("#coverageChecker #accordion .accordion-collapse").addClass("show");
        $("#coverageCheckerA #accordion .accordion-collapse").addClass("show");

        $("#coverageChecker #accordion .accordion-button").removeClass("collapsed");
        $("#coverageCheckerA #accordion .accordion-button").removeClass("collapsed");
      }, 1500);
    } else {
      //$("body").css("background-color", "#252525");
      //$("body").css("background-color", "#000000");
      $(".progress-container").show();
      $("#quizBranding").show();
      $("#questionnaire").css("min-height", "");
    }
  }

  function updateValues(slideClass, textboxId) {
    /*let values = [];
    $(slideClass + " input[type='checkbox']").each(function () {
      let state = $(this).is(":checked") ? "ON" : "OFF";
      //values.push($(this).val() + " is " + state);
      values.push(state);
    });*/
    let values = [];
    $(slideClass + " input[type='checkbox']").each(function () {
      if ($(this).is(":checked")) {
        let label = $("label[for='" + $(this).attr("id") + "']").text();
        values.push(label);
      }
    });
    $(textboxId).val(values.join(", "));
  }

  function updateValuesSlide3() {
    let values = [];
    let valuesShort = [];

    $("#q3a1B, #q3a2, #q3a3, #q3a4").each(function () {
      values.push($(this).val());
    });
    $("#textbox3").val(values.join(" "));
    var textbox3Values = $("#textbox3").val();

    $("#q3a1B, #q3a2, #q3a3").each(function () {
      valuesShort.push($(this).val());
    });
    var valuesShortB = valuesShort.join(" ");

    $(".resultsSlide .congratulationsMessage span").text(textbox3Values);
    $("#compatibleResults2").html(
      "<span>Compatible Features For Your</span> " + valuesShortB
    );
    $("#threeMatchesForYourCar").html(
      "3 Matches <small>for your</small><br> <span>" + valuesShortB + "</span>"
    );
  }

  function checkVehicleImageMatch() {
    const keywordsToCheck1 = [
      "ILX",
      "TLX",
      "CSX",
      "RLX",
      "TL",
      "RL",
      "A3",
      "A4",
      "A6",
      "A8",
      "3 Series",
      "5 Series",
      "7 Series",
      "CT4",
      "CT5",
      "CTS",
      "CTS-V",
      "Malibu",
      "Cruze",
      "Volt",
      "Caprice",
      "Impala",
      "300",
      "300C",
      "Charger",
      "Neon",
      "Dart",
      "Avenger",
      "Fusion",
      "Taurus",
      "G70",
      "G80",
      "G90",
      "Accord",
      "Civic",
      "Legend",
      "Elantra",
      "Sonata",
      "Accent",
      "G20",
      "G25",
      "G35",
      "Q45",
      "Q50",
      "Q70",
      "XE",
      "XF",
      "XJ",
      "K5",
      "Stinger",
      "ES",
      "IS",
      "LS",
      "Mazda3",
      "Mazda6",
      "C-Class",
      "E-Class",
      "S-Class",
      "Altima",
      "Maxima",
      "Sentra",
      "Versa",
      "Impreza",
      "Legacy",
      "Model 3",
      "Model S",
      "Avalon",
      "Camry",
      "Corolla",
      "Arteon",
      "Jetta",
      "Passat",
    ]; //Sedan
    const keywordsToCheck2 = [
      "MDX",
      "RDX",
      "Stelvio",
      "Q2",
      "Q3",
      "Q4",
      "Q5",
      "Q7",
      "Q8",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6",
      "X7",
      "Enclave",
      "Encore",
      "Envision",
      "Envista",
      "XT4",
      "XT5",
      "XT6",
      "Escalade",
      "Blazer",
      "Equinox",
      "Suburban",
      "Tahoe",
      "Traverse",
      "Trailblazer",
      "Trax",
      "Durango",
      "Bronco",
      "Edge",
      "Escape",
      "Explorer",
      "Expedition",
      "GV60",
      "GV70",
      "GV80",
      "Acadia",
      "Terrain",
      "Yukon",
      "CR-V",
      "HR-V",
      "Passport",
      "Pilot",
      "Element",
      "Crosstour",
      "Prologue",
      "Kona",
      "Palisade",
      "Santa Fe",
      "Santa Cruz",
      "Tucson",
      "Venue",
      "Nexo",
      "QX50",
      "QX60",
      "QX70",
      "QX80",
      "E-Pace",
      "F-Pace",
      "I-Pace",
      "Cherokee",
      "Grand Cherokee",
      "Renegade",
      "Wrangler",
      "Compass",
      "Seltos",
      "Sorento",
      "Sportage",
      "Telluride",
      "Discovery",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "NX",
      "RX",
      "GX",
      "LX",
      "Aviator",
      "Corsair",
      "Nautilus",
      "Navigator",
      "CX-3",
      "CX-30",
      "CX-5",
      "CX-50",
      "CX-9",
      "CX-8",
      "CX-80",
      "CX-90",
      "GLA",
      "GLB",
      "GLC",
      "GLE",
      "GLS",
      "Eclipse Cross",
      "Outlander",
      "Montero",
      "Armada",
      "Kicks",
      "Murano",
      "Pathfinder",
      "Rogue",
      "Juke",
      "Ariya",
      "Xterra",
      "Cayenne",
      "Macan",
      "Ascent",
      "Crosstrek",
      "XV",
      "Forester",
      "Outback",
      "Solterra",
      "Model X",
      "Model Y",
      "4Runner",
      "Highlander",
      "RAV4",
      "RAV-4",
      "Sequoia",
      "Venza",
      "Corolla Cross",
      "Land Cruiser",
      "Prado",
      "Atlas",
      "Tiguan",
      "Taos",
      "XC40",
      "XC60",
      "XC90",
    ]; //SUV
    const keywordsToCheck3 = [
      "Colorado",
      "Silverado 1500",
      "2500HD",
      "3500HD",
      "Maverick",
      "Ranger",
      "F-150",
      "F-250",
      "F-350",
      "Super Duty",
      "Canyon",
      "Sierra 1500",
      "Sierra",
      "Ridgeline",
      "Gladiator",
      "Frontier",
      "Titan",
      "Titan XD",
      "1500",
      "2500",
      "3500",
      "Tacoma",
      "Tundra",
      "Santa Cruz",
      "R1T",
    ]; //Pickup Truck
    const keywordsToCheck4 = [
      "Pacifica",
      "Voyager",
      "Town & Country",
      "Grand Caravan",
      "Caravan",
      "ProMaster",
      "Odyssey",
      "Carnival",
      "Sedona",
      "Sienna",
      "Previa",
      "City Express",
      "NV200",
    ]; //Minivan
    const keywordsToCheck5 = [
      "NSX",
      "Integra",
      "4C",
      "Giulia",
      "8C",
      "DB11",
      "Vantage",
      "DBS",
      "V12",
      "V8",
      "R8",
      "TT",
      "RS 4",
      "RS 5",
      "RS 6",
      "Z3",
      "Z4",
      "M2",
      "M4",
      "M8",
      "Camaro",
      "Corvette",
      "Challenger",
      "Viper",
      "488 GTB",
      "F8 Tributo",
      "Roma",
      "SF90 Stradale",
      "Mustang",
      "GT40",
      "GT",
      "Civic Type R",
      "Civic Type-R",
      "S2000",
      "Prelude",
      "Integra",
      "Coupe",
      "Veloster",
      "F-Type",
      "Stinger",
      "Aventador",
      "Huracan",
      "Urus",
      "Gallardo",
      "Murcielago",
      "SC",
      "LC",
      "RC",
      "RC F",
      "LFA",
      "LF-A",
      "Elise",
      "Evora GT",
      "Emira",
      "GranTurismo",
      "MC20",
      "MX-5",
      "MX5",
      "Miata",
      "720S",
      "Senna",
      "540C",
      "570S",
      "570GT",
      "620R",
      "765LT",
      "Artura",
      "P1",
      "AMG GT",
      "AMG SL",
      "370Z",
      "350Z",
      "Z",
      "GT-R",
      "Skyline",
      "Cayman",
      "Boxster",
      "911",
      "Taycan",
      "BRZ",
      "Roadster",
      "Celica",
      "Supra",
      "86",
      "Golf R",
      "GTI",
      "Polestar 1",
    ]; //Sports Car
    const keywordsToCheck6 = [
      "Caterpillar",
      "CAT",
      "Freightliner",
      "Kenworth",
      "Peterbilt",
      "Pierce",
      "Mack",
      "Volvo Trucks",
      "Western Star",
      "Kalmar",
      "International",
      "Navistar",
      "Isuzu",
      "Scania",
      "Hino",
      "Iveco",
      "PACCAR",
      "DAF",
      "Renault Trucks",
      "Nissan Diesel",
      "MAN",
    ]; //Truck

    const textToSearch = $("#q3a3").val().toLowerCase();
    const textToSearch2 = $("#q3a2").val().toLowerCase();

    const foundKeyword1 = keywordsToCheck1.find((keyword) =>
      textToSearch.includes(keyword.toLowerCase())
    ); // Sedan
    const foundKeyword2 = keywordsToCheck2.find((keyword) =>
      textToSearch.includes(keyword.toLowerCase())
    ); // SUV
    const foundKeyword3 = keywordsToCheck3.find((keyword) =>
      textToSearch.includes(keyword.toLowerCase())
    ); // Pickup Truck
    const foundKeyword4 = keywordsToCheck4.find((keyword) =>
      textToSearch.includes(keyword.toLowerCase())
    ); // Minivan
    const foundKeyword5 = keywordsToCheck5.find((keyword) =>
      textToSearch.includes(keyword.toLowerCase())
    ); // Sports Car
    const foundKeyword6 = keywordsToCheck6.find((keyword) =>
      textToSearch2.includes(keyword.toLowerCase())
    ); // Truck

    if (foundKeyword1) {
      var vehicleImageURL =
        "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/sedan_v2.png?v=1746535228"; //Sedan
    } else if (foundKeyword2) {
      var vehicleImageURL =
        "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/suv_v2.png?v=1746535228"; //SUV
    } else if (foundKeyword3) {
      var vehicleImageURL =
        "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pickup-truck_v2.png?v=1746535228"; //Pickup Truck
    } else if (foundKeyword4) {
      var vehicleImageURL =
        "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/van_v2.png?v=1746535228"; //Minivan
    } else if (foundKeyword5) {
      var vehicleImageURL =
        "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coupe_v2.png?v=1746535228"; //Sports Car
    } else if (foundKeyword6) {
      var vehicleImageURL =
        "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/truck_v2.png?v=1746535228"; //Truck
    } else {
      var vehicleImageURL =
        "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/sedan_v2.png?v=1746535228"; //Sedan (fallback, default)
    }

    $("#vehicleImageURL").attr("src", vehicleImageURL);
  }

  function getSlideData() {
    // Initial update for all slides
    updateValues(".slide1", "#textbox1");
    updateValues(".slide2", "#textbox2");
    updateValuesSlide3(".slide3", "#textbox3");
    updateValues(".slide4", "#textbox4");
    updateValues(".slide5", "#textbox5");

    // Update on change for all slides
    $(".slide1 input[type='checkbox']").on("change", function () {
      updateValues(".slide1", "#textbox1");
    });
    $(".slide2 input[type='checkbox']").on("change", function () {
      updateValues(".slide2", "#textbox2");
    });
    $(".slide3 input[type='checkbox']").on("change", function () {
      updateValuesSlide3(".slide3", "#textbox3");
    });
    $(".slide4 input[type='checkbox']").on("change", function () {
      updateValues(".slide4", "#textbox4");
    });
    $(".slide5 input[type='checkbox']").on("change", function () {
      updateValues(".slide5", "#textbox5");
    });
  }

  $(".go-to-slide-1").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(0);
    changeSlide($current, $target, "prev");
    updateProgressBar(1);
    $(
      "#coverageCheckerA, #deviceComparo, #resultsDetails, #threeMatchesForYourCar, .custom-scrollbar, .aseInfoRow.blackVersion.v2"
    ).hide();
    $(".aseInfoRow.whiteVersion, .aseInfoRow.blackVersion.v1").show();
    $(".nav-link-3.w-nav-link").hide();
  });

  $(".go-to-slide-2").click(function () {
    var $current = $(".slide.active");
    var $target = $(".slide").eq(1);
    changeSlide($current, $target, "next");
    updateProgressBar(2);
    $(
      "#coverageCheckerA, #deviceComparo, #resultsDetails, #threeMatchesForYourCar, .custom-scrollbar"
    ).show();
    $(".aseInfoRow.whiteVersion").hide();
    $(".nav-link-3.w-nav-link").show();
  });

  $(".next").click(function () {
    const activeSlide = $(".slide.active");

    if (
      !activeSlide.hasClass("slide2") &&
      !activeSlide.hasClass("slide3") &&
      !activeSlide.hasClass("slide4") &&
      !validateSlide()
    ) {
      //alert("Please select at least one option.");
      $(".slide.active .col-md-12").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select at least one above</div>'
      );
      return;
    }
    if (
      (activeSlide.hasClass("slide2") || activeSlide.hasClass("slide4")) &&
      !validateSlideSingle()
    ) {
      $(".slide.active .col-md-12").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select one above</div>'
      );
      return;
    }
    if (activeSlide.hasClass("slide3")) {
      if ($(".slide3 .unselected").length === 0) {
        $("#basicCoverageBtn").click();
        $("#coverageCheckerA").show();
        checkVehicleImageMatch();

        // Ensure the content is loaded
        setTimeout(function () {
          var replacements = [
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-error.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/red_x_mark.png",
            }, // X icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-success.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/green_check_mark.png",
            }, // Check icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-engine.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/engine_icon_v2.png",
            }, // Engine icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-abs.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/abs_brakes_icon_06d62931-075b-4b30-b8fe-8750f9ad1227.png",
            }, // ABS icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-srs.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/srs_and_airbags_icon_3b18da94-2579-4e30-881b-cea5e5b8063d.png",
            }, // Airbag icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/coverage2-tpms.svg?v=1711615509",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/tpms_icon_dd231821-aa87-416a-bdd9-c702d8fa2612.png",
            }, // TPMS icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/coverage2-tpms.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/tpms_icon_dd231821-aa87-416a-bdd9-c702d8fa2612.png",
            }, // TPMS icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/coverage2-network-scan.svg?v=1711615930",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/all_system_scan_icon_14a086c6-052c-49a1-bbd8-ed02c1c05959.png",
            }, // All System Scan icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/coverage2-network-scan.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/all_system_scan_icon_14a086c6-052c-49a1-bbd8-ed02c1c05959.png",
            }, // All System Scan icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-transmission.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/transmission_icon_72e5ccd3-334d-4d1d-9e50-bdf13438a974.png",
            }, // Transmission icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-info.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/info_mark.png",
            }, // Info icon
            {
              oldPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-info-red.svg",
              newPart:
                "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/question_mark.png",
            }, // Info icon red
          ];

          $("#accordion img").each(function () {
            var currentUrl = $(this).attr("src");
            replacements.forEach(function (replacement) {
              if (currentUrl.includes(replacement.oldPart)) {
                currentUrl = currentUrl.replace(
                  replacement.oldPart,
                  replacement.newPart
                );
              }
            });
            $(this).attr("src", currentUrl);
          });
        }, 1500);
      } else {
        //alert("Please complete all fields.");
        //return false;
        $(".slide.active .col-md-12").addClass("allFieldsAreRequired");
        $(".errorMessage1").remove();
        $(".form-group").append(
          '<div class="errorMessage1">Select all fields</div>'
        );
        return;
      }
    }
    var $current = $(".slide.active");
    var $next = $current.next(".slide");
    changeSlide($current, $next, "next");
    getSlideData();
  });

  $(".prev").click(function () {
    var $current = $(".slide.active");
    var $prev = $current.prev(".slide");
    changeSlide($current, $prev, "prev");
    const activeSlide = $(".slide.active");
    if (activeSlide.hasClass("slide1")) {
      $(".prev").hide();
    } else {
      $(".prev").show();
    }
  });

  $(".col-md-12 .checkbox-card, .col-md-12 .selectCoverageItem").click(
    function () {
      //alert("hello!");
      $(".allFieldsAreRequired").removeClass("allFieldsAreRequired");
    }
  );

  function submitDatas() {
    //var resultsSlideH1 = $("#textbox3").val();
    var textbox3 = $("#textbox3").val();
    var textbox3a1 = $("#q3a1B").val();
    var textbox3b1 = $("#q3a2").val();
    var textbox3c1 = $("#q3a3").val();
    $(".resultsSlide h1").html(
      '<span class="h1PlainTextA">Congratulations!</span><br><span class="h1BlackText">3 Matches</span> <span class="h1PlainText">for your</span><br>' +
        textbox3a1 +
        " " +
        textbox3b1 +
        " " +
        textbox3c1
    );
    $("#compatibleResults").html(
      "<span>Compatible Features For Your</span><br>" +
        textbox3a1 +
        " " +
        textbox3b1 +
        " " +
        textbox3c1
    );
    $("#compatibleResultsWrapper p span").html(textbox3);

    getSlideData();

    // Collect values from the consolidated textboxes
    let data = {
      textbox1: $("#textbox1").val(),
      textbox2: $("#textbox2").val(),
      textbox3: $("#textbox3").val(),
      textbox3a: $("#q3a1B").val(),
      textbox3b: $("#q3a2").val(),
      textbox3c: $("#q3a3").val(),
      textbox3d: $("#q3a4").val(),
      textbox4: $("#textbox4").val(),
      textbox5: $("#textbox5").val(),
    };

    //alert(data);
  }

  $(".submit").click(function () {
    if (!validateSlide()) {
      //alert("Please select at least one option.");
      $(".slide.active .col-md-12").addClass("allFieldsAreRequired");
      $(".errorMessage1").remove();
      $(".form-group").append(
        '<div class="errorMessage1">Select at least one above</div>'
      );
      return;
    }
    var $current = $(".slide.active");
    var $next = $current.next(".slide");
    $("html, body").animate({ scrollTop: 0 }, "fast");
    changeSlide($current, $next, "next");
    // Optionally, you can handle the form submission here
    submitDatas();
  });

  $("#coverageCheckerA #coverage-data .form-row").hide();
  $(".editVehicleForm").click(function () {
    //$("#coverageCheckerA #coverage-data .form-row").show();
    $("#coverageCheckerA #coverage-data .form-row").css("display", "grid");
    $("#coverageCheckerA #coverage-data .form-row:nth-of-type(2)").css({
      display: "block",
      margin: "0 auto",
      "max-width": "400px",
    });
    $("#coverageCheckerA #coverage-data .form-row:nth-of-type(2) *").css({
      display: "block",
      padding: "0",
      margin: "0",
      "max-width": "400px",
    });
    $(
      "#coverageCheckerA #coverage-data .form-row:nth-of-type(2) #basicCoverageBtn"
    ).css("padding", "10px");
  });

  // Initial adjustment of container height
  adjustContainerHeight();

  // Checkbox card click handling
  $(".checkbox-card").click(function () {
    var $checkbox = $($(this).data("target"));
    var image = $(this).data("image");
    var placeholder = $(this).data("placeholder");
    var $imageContainer = $(this)
      .closest(".question-row")
      .find(".image-container img");
    var $activeSlide = $(this).closest(".slide");

    if ($activeSlide.hasClass("slide2") || $activeSlide.hasClass("slide4")) {
      // Allow only one checkbox to be checked
      $activeSlide.find("input[type='checkbox']").prop("checked", false);
      $activeSlide.find(".checkbox-card").removeClass("checked");
    }

    $checkbox.prop("checked", !$checkbox.prop("checked"));
    $(this).toggleClass("checked", $checkbox.prop("checked"));

    if ($checkbox.prop("checked")) {
      $imageContainer.attr("src", image);
    } else {
      var checkedCheckboxes = $(this)
        .closest(".form-group")
        .find("input[type='checkbox']:checked");
      if (checkedCheckboxes.length > 0) {
        var newImage = checkedCheckboxes
          .first()
          .closest(".checkbox-card")
          .data("image");
        $imageContainer.attr("src", newImage);
      } else {
        $imageContainer.attr("src", placeholder);
      }
    }
  });

  $(".checkbox-card.noneSelected").click(function () {
    $(".slide5 input[type='checkbox']").prop("checked", false);
    $(".slide5 .checkbox-card").removeClass("checked");
    $(".slide5 #q5a4").prop("checked", true);
    $(".slide5 .checkbox-card.noneSelected").addClass("checked");
  });

  $(".checkbox-card.normalClick").click(function () {
    $(".slide5 #q5a4").prop("checked", false);
    $(".slide5 .checkbox-card.noneSelected").removeClass("checked");
  });

  function fadeInNewImage() {
    //$(".image-container img").hide("fast").fadeIn(500);
    $(".image-container img").hide().fadeIn(500);
  }

  // Monitor for changes to the image's src attribute
  $(".image-container img").on("load", function () {
    fadeInNewImage();
  });

  /* Landing Page Results Slider */
  var header = $("#shopify-section-header");
  var headerOffset = header.offset().top;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerOffset) {
      header.addClass("sticky");
    } else {
      header.removeClass("sticky");
    }
  });

  $("#logo-carousel-group").addClass("scrolling");

  function checkCustomVisibility() {
    $(".customFadeInElement").each(function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      if (elementBottom > viewportTop && elementTop < viewportBottom) {
        $(this).addClass("customVisible");
      }
    });
  }

  $(window).on("scroll resize", checkCustomVisibility);
  $(window).trigger("scroll");

  function syncSlideHeights() {
    var slide1Height = $(".slide1").outerHeight();
    //$(".slide1, .slide2, .slide3, .slide4, .slide5").height(slide1Height);
  }
  syncSlideHeights();
  $(window).resize(function () {
    syncSlideHeights();
  });

  if ($(window).width() < 768) {
    // Target mobile devices
    /*$(".third-column").css({
      "overflow-x": "scroll",
      "white-space": "nowrap",
    });*/
  }

  function adjustRowHeight() {
    if ($(window).width() < 768) {
      // Target mobile devices
      var colHeight = $("#deviceComparo .col-md-4").first().outerHeight();
      //$("#deviceComparo .row").css("height", colHeight);
    } else {
      //$("#deviceComparo .row").css("height", "auto");
    }
  }

  // Adjust height on page load
  adjustRowHeight();

  // Adjust height on window resize
  $(window).resize(function () {
    adjustRowHeight();
  });

  $(window).on(
    "resize",
    debounce(function () {
      //location.reload();
    }, 250)
  );

  function debounce(func, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  function isMobile() {
    return window.innerWidth <= 768; // Adjust the width as needed for your definition of mobile
  }

  function togglePosition() {
    var $nextButtonWrapper = $(".nextButtonWrapper");
    if ($(window).scrollTop() === 0) {
      /*$nextButtonWrapper.css({
        position: 'fixed',
        bottom: '0',
        boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)'
      });*/
    } else {
      /*$nextButtonWrapper.css({
        position: 'relative',
        bottom: 'auto',
        boxShadow: 'none'
      });*/
    }
  }

  function onScroll() {
    if (isMobile()) {
      togglePosition();
    }
  }

  // Initial check
  if (isMobile()) {
    togglePosition();
    $(window).on("scroll", onScroll);
  }

  // Check on resize
  $(window).on("resize", function () {
    if (isMobile()) {
      togglePosition();
      $(window).on("scroll", onScroll);
    } else {
      $(window).off("scroll", onScroll);
      /*$('.nextButtonWrapper').css({
        position: 'fixed',
        bottom: '0',
        boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)'
      });*/
    }
  });

  setTimeout(function () {
    var replacements = [
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-error.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/red_x_mark.png",
      }, // X icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-success.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/green_check_mark.png",
      }, // Check icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-engine.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/engine_icon_v2.png",
      }, // Engine icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-abs.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/abs_brakes_icon_06d62931-075b-4b30-b8fe-8750f9ad1227.png",
      }, // ABS icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-srs.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/srs_and_airbags_icon_3b18da94-2579-4e30-881b-cea5e5b8063d.png",
      }, // Airbag icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/coverage2-tpms.svg?v=1711615509",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/tpms_icon_dd231821-aa87-416a-bdd9-c702d8fa2612.png",
      }, // TPMS icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/coverage2-tpms.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/tpms_icon_dd231821-aa87-416a-bdd9-c702d8fa2612.png",
      }, // TPMS icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/coverage2-network-scan.svg?v=1711615930",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/all_system_scan_icon_14a086c6-052c-49a1-bbd8-ed02c1c05959.png",
      }, // All System Scan icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0739/4849/6150/files/coverage2-network-scan.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/all_system_scan_icon_14a086c6-052c-49a1-bbd8-ed02c1c05959.png",
      }, // All System Scan icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-transmission.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/transmission_icon_72e5ccd3-334d-4d1d-9e50-bdf13438a974.png",
      }, // Transmission icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-info.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/info_mark.png",
      }, // Info icon
      {
        oldPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/coverage2-info-red.svg",
        newPart:
          "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/question_mark.png",
      }, // Info icon red
    ];

    $("#accordion img").each(function () {
      var currentUrl = $(this).attr("src");
      replacements.forEach(function (replacement) {
        if (currentUrl.includes(replacement.oldPart)) {
          currentUrl = currentUrl.replace(
            replacement.oldPart,
            replacement.newPart
          );
        }
      });
      $(this).attr("src", currentUrl);
    });
  }, 1500);
});
